<template>
    <div :class="'type' + type" >
        <div
            :class="
                show_text_more && show_more && isentry
                    ? ' gl-snow blur-type-' +
                      isentry +
                      ' ' +
                      color +
                      ' blur-text'
                    : 'gl-snow'
            "
            style=""
        >
            <div
                :class="[`ql-editor text_edit ${color}`, {'lt-lg:text-center': text_center}]" 
                v-html="text_edit"
            ></div>
        </div>
        <div
            v-if="show_text_more"
            @click="show"
            :class="!show_more ? 'menej show ' + color : 'show ' + color"
        >
            {{ text_more }}
            <svg
                width="6"
                height="9"
                viewBox="0 0 6 9"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M0.834441 8.76553C0.684464 8.6155 0.600211 8.41206 0.600211 8.19993C0.600211 7.9878 0.684464 7.78435 0.834441 7.63433L3.46884 4.99993L0.83444 2.36553C0.758032 2.29173 0.697086 2.20345 0.655159 2.10585C0.613232 2.00825 0.591163 1.90327 0.59024 1.79705C0.589317 1.69082 0.609558 1.58548 0.649783 1.48716C0.690007 1.38885 0.74941 1.29953 0.824524 1.22441C0.899638 1.1493 0.98896 1.08989 1.08728 1.04967C1.18559 1.00944 1.29094 0.989202 1.39716 0.990126C1.50338 0.991049 1.60836 1.01312 1.70596 1.05505C1.80357 1.09697 1.89184 1.15792 1.96564 1.23433L5.16564 4.43433C5.31562 4.58435 5.39987 4.7878 5.39987 4.99993C5.39987 5.21206 5.31562 5.4155 5.16564 5.56553L1.96564 8.76553C1.81562 8.9155 1.61217 8.99976 1.40004 8.99976C1.18791 8.99976 0.984463 8.9155 0.834441 8.76553Z"
                    fill="white"
                />
            </svg>
        </div>
    </div>
</template>

<script>
import "../../../../public/css/texteditor.css";
export default {
    props: ["text", "color", "type", "isentry", "text_center"],
    data() {
        return {
            show_more: true,
            text_more: "Zobraziť viac",
            show_text_more: true,
        };
    },
    methods: {
        show() {
            if (this.show_more) this.text_more = "Zobraziť menej";
            else this.text_more = "Zobraziť viac";
            this.show_more = !this.show_more;
        },
    },
    computed: {
        text_edit() {
            var length = 300;
            if (this.text_length < 450) {
                this.show_text_more = false;
                return this.text;
            }
            let cleanCode = this.text.replace(/&nbsp;/g, "X!");
            if (
                cleanCode.charAt(cleanCode.length - 1) == "<" ||
                cleanCode.charAt(cleanCode.length - 1) == ">"
            ) {
                length -= 2;
            }
            cleanCode = cleanCode.slice(0, length);
            while (cleanCode.endsWith("X!")) {
                length += 2;
                cleanCode = cleanCode.slice(0, length);
            }
            cleanCode = cleanCode.replaceAll("X!", "&nbsp;");
            if (this.show_more) {
                return cleanCode + "...";
            } else return this.text;
        },
        text_length() {
            var cleanCode = this.text
                .replace(/<(?:.|\n)*?>/gm, "")
                .replace(/(\r\n|\n|\r)/gm, "")
                .replace(/&nbsp;/g, "");
            return cleanCode.trim().length;
        },
    },
};
</script>

<style lang="scss">
.gl-snow {
    position: relative;
}
.blur-text::after {
    content: "";
    position: absolute;
    bottom: 0;
    left: -12px;
    right: 0;
    height: 36px;
    filter: blur(5px);
}
.white.blur-text::after {
    background: linear-gradient(to bottom, rgba(255, 255, 255, 0), #f7f8f8);
}
.type8 .white.blur-text::after,
.type7 .white.blur-text::after,
.type4 .white.blur-text::after {
    background: linear-gradient(to bottom, rgba(255, 255, 255, 0), white);
}
.type3 {
    .blur-type-1.white.blur-text::after {
        background: linear-gradient(to bottom, rgba(255, 255, 255, 0), white);
    }
    .blur-type-2.white.blur-text::after {
        background: linear-gradient(to bottom, rgba(255, 255, 255, 0), #f6f9fd);
    }
}
.cards_homesystem .white.blur-text::after {
    background: linear-gradient(to bottom, rgba(255, 255, 255, 0), white);
}
.blur-type-2.white.blur-text::after {
    background: linear-gradient(to bottom, rgba(255, 255, 255, 0), white);
}

.black.blur-text::after {
    background: linear-gradient(to bottom, transparent, #0f1615);
}
.blur-type-2.black.blur-text::after {
    background: linear-gradient(to bottom, transparent, #000807);
}
.ql-editor {
    height: auto !important;
    padding-left: 0 !important;
}
.text_edit {
    white-space: break-spaces;
    position: relative;
    margin-bottom: 0;
    padding-bottom: 0;
    p {
        margin-bottom: 0;
    }
}
.type3 {
    .text_edit.white {
        color: #000 !important;
        p,
        span,
        strong,
        ul li,
        ol li,
        u {
            font-size: 14px !important;
            line-height: 183.5% !important;
            color: #000 !important;
        }
    }
}
.pivovar {
    .text_edit.white {
        color: #1b4524 !important;
        p,
        span,
        strong,
        ul li,
        ol li,
        u {
            font-size: 14px !important;
            line-height: 183.5% !important;
            color: #1b4524 !important;
        }
    }
}
.text_edit.white {
    color: #000 !important;
    p,
    span,
    strong,
    ul li,
    ol li,
    u {
        font-size: 14px !important;
        line-height: 183.5% !important;
        color: #000 !important;
    }
}
.text_edit.black {
    color: #fff !important;
    p,
    span,
    strong,
    ul li,
    ol li,
    u {
        font-size: 14px !important;
        line-height: 183.5% !important;
        color: #fff !important;
    }
}
</style>
<style lang="scss" scoped>
.pivovar {
    .type5 {
        .show.white {
            color: #fff !important;
            svg {
                path {
                    fill: #fff !important;
                }
            }
        }
    }
}
.type8 {
    .show.white {
        color: #747474 !important;
        svg {
            path {
                fill: #747474 !important;
            }
        }
    }
}
.type3 {
    .content {
        p.text {
            .type3 {
                .show.white {
                    color: #fff !important;
                    svg {
                        path {
                            fill: #fff !important;
                        }
                    }
                }
            }
        }
    }
}
.type3 {
    .show.white {
        color: #000 !important;
        svg {
            path {
                fill: #000 !important;
            }
        }
    }
}
.show {
    width: fit-content;
    margin-top: 5px;
    cursor: pointer;
    display: flex;
    align-items: center;
    font-weight: bold;
    font-size: 14px;
    line-height: 183.5%;
    @media only screen and (max-width: 600px) {
        margin: 0 auto;
    }
    svg {
        margin-left: 8px;
        margin-bottom: 2px;
    }
    &.white {
        color: #212541 !important;
        svg {
            path {
                fill: #212541 !important;
            }
        }
    }
    &.menej {
        color: #fff;
        svg {
            transform: rotate(270deg);
        }
    }
}
.pivovar {
    .show {
        &.white {
            color: #1b4524 !important;
            svg {
                path {
                    fill: #1b4524 !important;
                }
            }
        }
    }
}
</style>
